var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './sds-toggle.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * A toggle component that provides a switch-like interface for boolean values.
 *
 * @fires sds.toggle.changed - Fired when the toggle state changes
 * @fires focus - Fired when the toggle receives focus
 * @fires blur - Fired when the toggle loses focus
 * @fires click - Fired when the toggle is clicked
 */
let SdsToggle = (() => {
    var _SdsToggle_label_accessor_storage, _SdsToggle_description_accessor_storage, _SdsToggle__toggle_accessor_storage, _SdsToggle_checked_accessor_storage, _SdsToggle_disabled_accessor_storage, _SdsToggle_align_accessor_storage, _SdsToggle_size_accessor_storage, _SdsToggle_invalid_accessor_storage, _SdsToggle_errorMessage_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-toggle')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _label_decorators;
    let _label_initializers = [];
    let _label_extraInitializers = [];
    let _description_decorators;
    let _description_initializers = [];
    let _description_extraInitializers = [];
    let __toggle_decorators;
    let __toggle_initializers = [];
    let __toggle_extraInitializers = [];
    let _checked_decorators;
    let _checked_initializers = [];
    let _checked_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _align_decorators;
    let _align_initializers = [];
    let _align_extraInitializers = [];
    let _size_decorators;
    let _size_initializers = [];
    let _size_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    var SdsToggle = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsToggle_label_accessor_storage.set(this, __runInitializers(this, _label_initializers, ''));
            _SdsToggle_description_accessor_storage.set(this, (__runInitializers(this, _label_extraInitializers), __runInitializers(this, _description_initializers, '')));
            _SdsToggle__toggle_accessor_storage.set(this, (__runInitializers(this, _description_extraInitializers), __runInitializers(this, __toggle_initializers, void 0)));
            _SdsToggle_checked_accessor_storage.set(this, (__runInitializers(this, __toggle_extraInitializers), __runInitializers(this, _checked_initializers, false)));
            _SdsToggle_disabled_accessor_storage.set(this, (__runInitializers(this, _checked_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsToggle_align_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _align_initializers, 'start')));
            _SdsToggle_size_accessor_storage.set(this, (__runInitializers(this, _align_extraInitializers), __runInitializers(this, _size_initializers, 'lg')));
            _SdsToggle_invalid_accessor_storage.set(this, (__runInitializers(this, _size_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsToggle_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            /** Internal state tracking whether the toggle is focused */
            this._isFocused = (__runInitializers(this, _errorMessage_extraInitializers), false);
            /** Internal state tracking whether the toggle was clicked */
            this._isClicked = false;
        }
        /**
         * The label text displayed next to the toggle
         * @attr
         */
        get label() { return __classPrivateFieldGet(this, _SdsToggle_label_accessor_storage, "f"); }
        set label(value) { __classPrivateFieldSet(this, _SdsToggle_label_accessor_storage, value, "f"); }
        /**
         * Additional descriptive text displayed below the label
         * @attr
         */
        get description() { return __classPrivateFieldGet(this, _SdsToggle_description_accessor_storage, "f"); }
        set description(value) { __classPrivateFieldSet(this, _SdsToggle_description_accessor_storage, value, "f"); }
        /** Reference to the underlying checkbox input element */
        get _toggle() { return __classPrivateFieldGet(this, _SdsToggle__toggle_accessor_storage, "f"); }
        set _toggle(value) { __classPrivateFieldSet(this, _SdsToggle__toggle_accessor_storage, value, "f"); }
        /**
         * The checked state of the toggle
         * @attr
         */
        get checked() { return __classPrivateFieldGet(this, _SdsToggle_checked_accessor_storage, "f"); }
        set checked(value) { __classPrivateFieldSet(this, _SdsToggle_checked_accessor_storage, value, "f"); }
        /**
         * Whether the toggle is disabled and cannot be interacted with
         * @attr
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsToggle_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsToggle_disabled_accessor_storage, value, "f"); }
        /**
         * The alignment of the toggle relative to its label
         * @attr
         * @deprecated Use 'start' or 'end' instead of 'left' or 'right'
         */
        get align() { return __classPrivateFieldGet(this, _SdsToggle_align_accessor_storage, "f"); }
        set align(value) { __classPrivateFieldSet(this, _SdsToggle_align_accessor_storage, value, "f"); }
        /**
         * The size of the toggle
         * @attr
         */
        get size() { return __classPrivateFieldGet(this, _SdsToggle_size_accessor_storage, "f"); }
        set size(value) { __classPrivateFieldSet(this, _SdsToggle_size_accessor_storage, value, "f"); }
        /**
         * Whether the toggle is in an invalid state
         * @attr
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsToggle_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsToggle_invalid_accessor_storage, value, "f"); }
        /**
         * Error message to display when the toggle is invalid
         * @attr error-message
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsToggle_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsToggle_errorMessage_accessor_storage, value, "f"); }
        /**
         * Programmatically focuses the toggle
         * @public
         */
        focus() {
            this._toggle.focus();
            this._isFocused = true;
            this.requestUpdate();
        }
        /**
         * Programmatically clicks the toggle
         * @public
         */
        click() {
            this._toggle.click();
        }
        /**
         * Handles focus events on the toggle
         * @protected
         */
        handleFocus() {
            if (!this._isClicked) {
                this._isFocused = true;
            }
            this.requestUpdate();
            // Dispatch a custom focus event
            this.dispatchEvent(new CustomEvent(SdsToggle.FOCUS_EVENT, {
                bubbles: false,
                composed: false,
            }));
        }
        /**
         * Handles blur events on the toggle
         * @protected
         */
        handleBlur() {
            this._isFocused = false;
            this._isClicked = false;
            this.requestUpdate();
            // Dispatch a custom blur event
            this.dispatchEvent(new CustomEvent(SdsToggle.BLUR_EVENT, {
                bubbles: false,
                composed: false,
            }));
        }
        /**
         * Handles click events on the toggle
         * @protected
         */
        handleClick() {
            if (!this._isClicked) {
                this._isFocused = false;
            }
            this._isClicked = true;
            // Toggle the checkbox state
            this.dispatchEvent(new CustomEvent(SdsToggle.CLICK_EVENT, {
                bubbles: false,
                composed: false,
            }));
        }
        /**
         * Handles keyboard events for accessibility
         * Supports Space and Enter keys for toggling
         * @protected
         * @param e - The keyboard event
         */
        handleKeyDown(e) {
            // Handle Space key for toggling the switch
            if (e.key === ' ' || e.key === 'Space' || e.key === 'Spacebar') {
                e.preventDefault();
                if (!this.disabled) {
                    this.checked = !this.checked;
                    this.requestUpdate();
                    this.dispatchEvent(new CustomEvent(SdsToggle.CHANGED_EVENT, {
                        detail: { checked: this.checked },
                        bubbles: false,
                        composed: false,
                    }));
                }
                return;
            }
            // Handle Enter key for toggling the switch (for consistency with other form controls)
            if (e.key === 'Enter') {
                e.preventDefault();
                if (!this.disabled) {
                    this.checked = !this.checked;
                    this.requestUpdate();
                    this.dispatchEvent(new CustomEvent(SdsToggle.CHANGED_EVENT, {
                        detail: { checked: this.checked },
                        bubbles: false,
                        composed: false,
                    }));
                }
                return;
            }
        }
        /**
         * Handles change events from the underlying checkbox
         * @protected
         */
        handleChange() {
            this.checked = this._toggle.checked;
            const changed = new CustomEvent(SdsToggle.CHANGED_EVENT, {
                detail: { checked: this.checked },
                bubbles: false,
                composed: false,
            });
            this.dispatchEvent(changed);
        }
        /**
         * Lifecycle callback that runs after updates
         * Ensures the checkbox state matches the component state
         * @public
         */
        updated() {
            this._toggle.checked = this.checked;
        }
        /**
         * Renders the toggle component
         * @public
         * @returns The rendered template
         */
        render() {
            return html `
            <div class="${this.getClasses()}">
                <label
                    class="sds-toggle__switcher"
                    @keydown="${(e) => this.handleKeyDown(e)}"
                    @click="${() => this.handleClick()}"
                >
                    <input
                        class="sds-toggle__input"
                        type="checkbox"
                        ?checked="${this.checked}"
                        ?disabled="${this.disabled}"
                        @change="${() => this.handleChange()}"
                        @focus="${() => this.handleFocus()}"
                        @blur="${() => this.handleBlur()}"
                        role="switch"
                        aria-checked="${this.checked}"
                        aria-disabled="${this.disabled}"
                        aria-invalid="${this.invalid}"
                        aria-label="${this.label || 'Toggle'}"
                        aria-describedby="${this.description ? 'toggle-description' : ''}"
                    />
                </label>
                ${this.renderContent()}
            </div>
            ${this.renderError()}
        `;
        }
        /**
         * Renders the label and description content
         * @private
         * @returns The rendered content template
         */
        renderContent() {
            return html `
            ${this.label || this.description
                ? html ` <div
                      class="sds-toggle__content"
                      @click="${(e) => e.stopPropagation()}"
                  >
                      ${this.label
                    ? html ` <div class="sds-toggle__label">${this.label}</div>`
                    : html ``}
                      ${this.description
                    ? html ` <div class="sds-toggle__description" id="toggle-description">
                                ${this.description}
                            </div>`
                    : html ``}
                  </div>`
                : html ``}
        `;
        }
        /**
         * Renders the error message when the toggle is invalid
         * @public
         * @returns The rendered error message template or undefined
         */
        renderError() {
            if (this.errorMessage && this.invalid) {
                return html ` <sds-error message="${this.errorMessage}"></sds-error> `;
            }
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        /**
         * Generates the CSS classes for the toggle based on its state
         * @protected
         * @returns The class map directive result
         */
        getClasses() {
            return classMap({
                'sds-toggle': true,
                'sds-toggle--lg': this.size === 'lg' || this.size === 'md',
                'sds-toggle--sm': this.size === 'sm',
                'sds-toggle--checked': this.checked,
                'sds-toggle--disabled': this.disabled,
                'sds-toggle--invalid': this.invalid,
                'sds-toggle--focused': this._isFocused,
                [this._getAlignClass()]: true,
            });
        }
        /**
         * Internal click handler
         * @private
         */
        _handleClick() {
            if (!this.disabled) {
                this.checked = !this.checked;
                this.dispatchEvent(new CustomEvent('change', {
                    detail: { checked: this.checked },
                    bubbles: true,
                    composed: true,
                }));
            }
        }
        /**
         * Gets the alignment class based on the align property
         * Handles backward compatibility for 'left' and 'right' values
         * @private
         * @returns The alignment class name
         */
        _getAlignClass() {
            // Map old values to new ones for backward compatibility
            if (this.align === 'left')
                return 'sds-toggle--start';
            if (this.align === 'right')
                return 'sds-toggle--end';
            return `sds-toggle--${this.align}`;
        }
        /**
         * Handles click events on the input element
         * @protected
         * @param e - The click event
         */
        handleInputClick(e) {
            // Prevent the default behavior which would toggle the checkbox after focus
            e.preventDefault();
            // Toggle the checkbox state
            if (!this.disabled) {
                this.checked = !this.checked;
                this.dispatchEvent(new CustomEvent(SdsToggle.CHANGED_EVENT, {
                    detail: { checked: this.checked },
                    bubbles: false,
                    composed: false,
                }));
            }
            // Set clicked state but don't set focus state
            this._isClicked = true;
            this.requestUpdate();
        }
    };
    _SdsToggle_label_accessor_storage = new WeakMap();
    _SdsToggle_description_accessor_storage = new WeakMap();
    _SdsToggle__toggle_accessor_storage = new WeakMap();
    _SdsToggle_checked_accessor_storage = new WeakMap();
    _SdsToggle_disabled_accessor_storage = new WeakMap();
    _SdsToggle_align_accessor_storage = new WeakMap();
    _SdsToggle_size_accessor_storage = new WeakMap();
    _SdsToggle_invalid_accessor_storage = new WeakMap();
    _SdsToggle_errorMessage_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsToggle");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _label_decorators = [property({ type: String })];
        _description_decorators = [property({ type: String })];
        __toggle_decorators = [query('input[type=checkbox]')];
        _checked_decorators = [property({ type: Boolean })];
        _disabled_decorators = [property({ type: Boolean })];
        _align_decorators = [property({ type: String })];
        _size_decorators = [property({ type: String })];
        _invalid_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        __esDecorate(_classThis, null, _label_decorators, { kind: "accessor", name: "label", static: false, private: false, access: { has: obj => "label" in obj, get: obj => obj.label, set: (obj, value) => { obj.label = value; } }, metadata: _metadata }, _label_initializers, _label_extraInitializers);
        __esDecorate(_classThis, null, _description_decorators, { kind: "accessor", name: "description", static: false, private: false, access: { has: obj => "description" in obj, get: obj => obj.description, set: (obj, value) => { obj.description = value; } }, metadata: _metadata }, _description_initializers, _description_extraInitializers);
        __esDecorate(_classThis, null, __toggle_decorators, { kind: "accessor", name: "_toggle", static: false, private: false, access: { has: obj => "_toggle" in obj, get: obj => obj._toggle, set: (obj, value) => { obj._toggle = value; } }, metadata: _metadata }, __toggle_initializers, __toggle_extraInitializers);
        __esDecorate(_classThis, null, _checked_decorators, { kind: "accessor", name: "checked", static: false, private: false, access: { has: obj => "checked" in obj, get: obj => obj.checked, set: (obj, value) => { obj.checked = value; } }, metadata: _metadata }, _checked_initializers, _checked_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _align_decorators, { kind: "accessor", name: "align", static: false, private: false, access: { has: obj => "align" in obj, get: obj => obj.align, set: (obj, value) => { obj.align = value; } }, metadata: _metadata }, _align_initializers, _align_extraInitializers);
        __esDecorate(_classThis, null, _size_decorators, { kind: "accessor", name: "size", static: false, private: false, access: { has: obj => "size" in obj, get: obj => obj.size, set: (obj, value) => { obj.size = value; } }, metadata: _metadata }, _size_initializers, _size_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsToggle = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    /** Event fired when the toggle state changes */
    _classThis.CHANGED_EVENT = 'sds.toggle.changed';
    /** Event fired when the toggle receives focus */
    _classThis.FOCUS_EVENT = 'focus';
    /** Event fired when the toggle loses focus */
    _classThis.BLUR_EVENT = 'blur';
    /** Event fired when the toggle is clicked */
    _classThis.CLICK_EVENT = 'click';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsToggle = _classThis;
})();
export { SdsToggle };
